<template>
  <div class="vertical-divider"></div>
</template>

<script>
export default {
  name: "VerticalDivider"
};
</script>

<style lang="scss" scoped>
.vertical-divider {
  background-color: #4fa800;
  height: 2px;
  margin: 40px 0;
}
</style>
